import { useAppSelector } from '@/redux/store'
import { ProductTypes } from '@/modules/base/util/constants'
import useSubscriptionProducts from '@/modules/moduleSubscription/components/list/useSubscriptionProducts'
import subscriptionPlanOrder from '@/modules/base/components/modal/upgrade-modal/subscription-selection/_helpers/mboSubscriptionPlanOrder'
import { getUpgradeLink } from '@/modules/base/components/modal/upgrade-modal/subscription-selection/subscription-selection.meinbuero'
import { createButtonLink, getNextPlan, getPlanButtonItem } from '@/modules/moduleSubscription/components/_helpers/planCheckout'
import { usePlanCheckout } from '@/modules/moduleSubscription/components/_helpers/usePlanCheckout'

// Shared by revenue-limit-notch and revenue-limit-warning so both link straight to the
// tenant's next-plan purchase flow instead of a generic shop navigation.
export const useRevenueLimitUpgrade = () => {
  const subscriptions = useAppSelector(state => state.subscription.details.subscriptions)
  const { subscriptionProducts } = useSubscriptionProducts()
  const { checkout, marketplaceForm } = usePlanCheckout()

  const upgrade = () => {
    const product = subscriptionProducts?.[ProductTypes.MAIN]
    const currentSubscription = subscriptions.find(sub => sub.typeOfSubscription === ProductTypes.MAIN)
    const relatedSubscription = subscriptions.find(sub => sub.typeOfSubscription === ProductTypes.MAIN && !sub.isTrial)
    const nextPlan = currentSubscription && getNextPlan(product?.plans, subscriptionPlanOrder[ProductTypes.MAIN], currentSubscription.type)
    const buttonItem = nextPlan && getPlanButtonItem(nextPlan, relatedSubscription)
    const upgradeLink = nextPlan && getUpgradeLink(product, relatedSubscription, nextPlan)

    const buttonLink = buttonItem && createButtonLink({
      typeOfSubscription: ProductTypes.MAIN,
      serial: product.serial,
      relatedSubscription,
      upgradeLink,
      value: buttonItem.value,
    })

    if (!buttonLink) return

    checkout(buttonLink, { isMarketplace: buttonItem.metaData?.shopType === 'marketplace' })
  }

  return { upgrade, marketplaceForm }
}
